import { render, staticRenderFns } from "./VehicleDataForm.vue?vue&type=template&id=549745ed&"
import script from "./VehicleDataForm.controller.js?vue&type=script&lang=js&"
export * from "./VehicleDataForm.controller.js?vue&type=script&lang=js&"
import style0 from "./VehicleDataForm.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports